import { formatDate, gridSize, gridSizeMdLg12, gridSizeMdLg4, newSolicitudesIngresoSchema, ROUTER_PATHS, texto } from "@/shared";
import { useCreateSolicitudesIngresos, useFetchBodegas, useFetchUbicaciones } from "@/shared/actions/erp";
import { LoaderComponent, SampleDatePicker, SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui";
import { AlertSeverityEnum, MaterialTransferido, SaveSolicitudIngresoFormData } from "@/shared/interfaces";
import { BODEGAS, TiposBodegaEnum, TipoUbicacionEnum, Ubicaciones } from "@/shared/interfaces/erp/inventario";
import { yupResolver } from "@hookform/resolvers/yup";
import { Divider, Grid, Paper, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import ModalProductoComponente from "./ModalProductoComponente";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import useTableColumnsSolicitudIngreso from "@/shared/hooks/useTableColumnsSolicitudIngreso";
import { useUiStore } from "@/store/ui";
import { useNavigate } from "react-router-dom";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useEffect, useRef } from "react";
import CustomTextFielRead from "@/shared/components/ui/CustomTextFielRead";
import { useAuthStore } from "@/store/auth";
import { toast } from "react-toastify";



type SaveSolicitudesIngresosProps = {
  title: string;
}
export default function SaveSolicitudesIngresos({ title }: SaveSolicitudesIngresosProps) {
  //const user = us
  const email_remitente = useAuthStore.getState().user?.email ?? '';

  //store
  const { columnsSolicitudIngreso } = useTableColumnsSolicitudIngreso()
  //const handldeCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const handleAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const setAlert = useUiStore(s => s.setAlert)
  const navigate = useNavigate()
   console.log('productos',productos)

  //*form
  const form = useForm<SaveSolicitudIngresoFormData>({
    resolver: yupResolver(newSolicitudesIngresoSchema),
  })
  const { control,
    handleSubmit,
    reset,
    formState: { errors }
  } = form

  //* FETCH
  const { data: dataBodegas, isLoading: isLoadingBodega } =
    useFetchBodegas({
      page_size: 600,
      nombre: TiposBodegaEnum.BODEGA_MATRIZ_QUITO

    })
  //console.log('Bodega', dataBodegas)
  const { data: dataubicacion, isLoading: isLoadingUbicacion } = useFetchUbicaciones({
    page_size: 600,
    bodega: dataBodegas?.data?.data[0]?.codigo,
    nombre: TipoUbicacionEnum.GENERICA
  }, !!dataBodegas?.data?.data[0]?.codigo)

  const crearSolicitudIngreso = useCreateSolicitudesIngresos({})

  useEffect(() => {

    const bodega = dataBodegas?.data?.data[0]?.codigo
    const ubicacion = dataubicacion?.data?.data[0]?.codigo
    const email_receptor = dataBodegas?.data?.data[0]?.email

    if (bodega && !form.getValues('bodega')) {
      form.setValue('bodega', bodega)
    }
    if (ubicacion && !form.getValues('ubicacion')) {
      form.setValue('ubicacion', ubicacion)
    }

    form.setValue('email_remitente', email_remitente)
    form.setValue('email_receptor', email_receptor!)

  }, [isLoadingBodega, isLoadingUbicacion, dataBodegas, dataubicacion])

  const ref = useRef(false)
  useEffect(() => {

    if (ref.current) return;
    if (isLoadingBodega || isLoadingUbicacion) return;

    const { bodega, ubicacion, email_receptor } = form.getValues();

    ref.current = true

    if (!bodega || !ubicacion) {
      toast.error('La ubicación generica no existe en la bodega Matriz Quito.')
      navigate(ROUTER_PATHS.inventario.solicitud_ingreso_compraNav);
      return;
    }

    if (!email_receptor) {
      toast.error('El email no existe en la bodega Matriz Quito')
      navigate(ROUTER_PATHS.inventario.solicitud_ingreso_compraNav);
    }
  }, [isLoadingBodega, isLoadingUbicacion])

  //*onSave
  const onSubmit = (e: any) => {
    if (productos.length === 0)
      return setAlert(true, 'No  has seleccionado ningun producto.', AlertSeverityEnum.error)
    if (e.stock_actual <= 0)
      return setAlert(true, `El producto ${e.descripcion} no tiene stock disponible (${e.stock_actual}).`, AlertSeverityEnum.warning)

    const validaCantidad = productos.find(item => Number(item.cantidad) <= 0)
    if (validaCantidad) {
      setAlert(true, `El producto "${validaCantidad.codigo}", tiene una cantidad inválida, debe ser mayor a cero.`, AlertSeverityEnum.error)
      return;
    }

    setConfirmDialogIsOpen(true)
    setConfirmDialog({
      cancelTextBtn: 'Cancelar',
      isOpen: true,
      title: "¡Atención! Confirmación de solicitud",
      subtitle: "¿Estás seguro de que deseas generar la solicitud?",
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: async () => {
        setConfirmDialogIsOpen(false)


        const solicitudIngreso = {
          ...e,
          productos: productos,
          /* urls_imagenes: {
            archivoSolicitud
          } */
        } as any
        /*  console.log(solicitudIngreso)
         return; */
        const respSolicitudIngreso = await crearSolicitudIngreso.mutateAsync(solicitudIngreso)
        if (respSolicitudIngreso.code !== 200)
          return
        navigate(ROUTER_PATHS.inventario.solicitud_ingreso_compraNav)
        clearSelectedItems()
      }
    })

  }
  useEffect(() => {
    return () => {
      reset();
      clearSelectedItems();
      form.setValue('ubicacion', '')
    }
  }, [])
  //
  if (isLoadingBodega || isLoadingUbicacion) return <LoaderComponent />
  return (
    <>
      <SingleTableBoxScene
        title={title}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.solicitud_ingreso_compraNav}
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Crear Solicitud"
        iconCreateOrEdit={<TaskAltIcon />}
        fnCreateOrEdit={handleSubmit(onSubmit,
          (errors) => { console.log(errors) /* setAlert(true, 'Campos Obligatorios.', AlertSeverityEnum.error) */ }
        )}
      >
        <Grid container spacing={3}>
          <Grid item {...gridSizeMdLg12}>
            <Paper variant="outlined" sx={{ p: 2, width: '100%', mx: 'auto' }}>
              <Grid>
                <Typography variant="h6" sx={{ color: '#717a8ab0' }}>{'Información General'}</Typography>
              </Grid>
              <Divider sx={{ my: 2.5 }} />
              <Grid container spacing={2}>
                <SampleDatePicker
                  disabled={true}
                  label="Fecha creación"
                  control={control}
                  error={errors.fecha_creacion}
                  helperText={errors.fecha_creacion?.message}
                  name="fecha_creacion"
                  textFieldKey="fecha_creacion"
                  size={gridSizeMdLg4}
                  defaultValue={formatDate(new Date()) || ''}
                />
                <CustomTextFielRead<BODEGAS>
                  label={texto.bodega}
                  name="bodega"
                  valueKey={"nombre"}
                  actualValueKey={"codigo"}
                  isLoadingData={isLoadingBodega}
                  control={form.control}
                  defaultValue={form.getValues().bodega || ''}
                  value={dataBodegas?.data?.data[0]}
                  size={gridSizeMdLg4}
                />
                <CustomTextFielRead<Ubicaciones>
                  label={'Ubicación'}
                  name="ubicacion"
                  valueKey={"nombre"}
                  actualValueKey={"codigo"}
                  isLoadingData={isLoadingUbicacion}
                  control={form.control}
                  defaultValue={form.getValues().ubicacion || ''}
                  //defaultValue={dataubicacion?.data?.data[0]?.codigo || ''}
                  value={dataubicacion?.data?.data[0]}
                  size={gridSizeMdLg4}
                />
                <Grid item {...gridSizeMdLg12}>
                  <TextField
                    {...form.register("observaciones.observacionSolicitante", {
                      onChange: (e) => {
                        e.target.value = e.target.value.toUpperCase();
                        form.setValue("observaciones.observacionSolicitante", e.target.value)
                      }
                    })} //captura
                    variant="outlined"
                    label="Observación"
                    multiline
                    rows={2}
                    fullWidth
                    error={!!errors.observaciones?.observacionSolicitante}
                    helperText={errors.observaciones?.observacionSolicitante?.message}
                    required={true}
                  />
                </Grid>

              </Grid>

            </Paper>
          </Grid>

          <Grid item {...gridSize}>
            <Paper className="paper-prodcuto">
              <Grid container spacing={1} justifyContent={"space-between"} alignItems={"center"}>
                <Grid item>
                  <TabTextLabel text={'Items Seleccionado'} mt={0} pb={0} pl={1} pt={0} />
                </Grid>
                <Grid item>
                  <ModalProductoComponente
                    ubicacion={form.watch('ubicacion')}
                    onChange={(e) => {

                      const aux: MaterialTransferido = {
                        id: e.id_producto,
                        codigo: e.codigo,
                        cantidad: '1',
                        contiene_serie: e.contiene_serie,
                        producto_data: {
                          codigo: e.codigo,
                          categoria_producto: e.categoria_producto,
                          subcategoria_producto: e.subcategoria_producto,
                          descripcion: e.descripcion,
                          stock_actual: e.stockActual,
                          modelo_producto: e.modelo_producto,
                          marca_producto: e.marca_producto,
                          unidad_medida: e.unidad_medida,
                          presentacion: e.presentacion,
                        },
                        series: [],
                      }

                      
                      handleAgregarProducto(aux)
                    }}
                  />
                </Grid>
                <div className="linea" />
                <Grid item xs={12}>
                  <SampleTablePagination
                    columns={columnsSolicitudIngreso}
                    data={paginatedData}
                    rowCount={productos.length}
                    setPagination={setPagination}
                    pagination={pagination}
                    rowNumber={true}
                  //density="compact"
                  />

                </Grid>

              </Grid>

            </Paper>

          </Grid>
        </Grid>

      </SingleTableBoxScene>
    </>
  )
}